!function(){

// ── Fetch intercept ──────────────────────────────────────────────────────
// Enhancify builder bug: inventory_policy=continue + quantityAvailable=0
// shows "OUT OF STOCK" instead of "Pre-Order (Expected: date)".
// Fix: intercept Storefront API GraphQL responses and change quantityAvailable
// from 0 → -1 when availableForSale=true (continue-selling variant).
// The builder already handles -1 correctly; we just make 0 look like -1.
(function(){
  var orig=window.fetch;
  window.fetch=function(url,opts){
    var p=orig.apply(this,arguments);
    try{
      var u=url&&url.toString?url.toString():'';
      if(u.indexOf('graphql')!==-1){
        return p.then(function(res){
          if(!res||!res.ok)return res;
          return res.clone().json().then(function(data){
            if(!patchQty(data))return res;
            return new Response(JSON.stringify(data),{
              status:res.status,
              statusText:res.statusText,
              headers:{'Content-Type':'application/json'}
            });
          }).catch(function(){return res;});
        }).catch(function(){return p;});
      }
    }catch(e){}
    return p;
  };
  function patchQty(obj){
    if(!obj||typeof obj!=='object')return false;
    if(Array.isArray(obj)){
      var m=false;obj.forEach(function(i){if(patchQty(i))m=true;});return m;
    }
    var mod=false;
    if('quantityAvailable'in obj&&obj.quantityAvailable===0&&obj.availableForSale===true){
      obj.quantityAvailable=-1;mod=true;
    }
    Object.keys(obj).forEach(function(k){if(patchQty(obj[k]))mod=true;});
    return mod;
  }
})();

// ── CSS ─────────────────────────────────────────────────────────────────────
var s=document.createElement('style');
s.textContent='body.dogg-modal .dogg-modal-target{position:fixed!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important;width:min(900px,90vw)!important;height:85vh!important;max-height:85vh!important;overflow-y:auto!important;overflow-x:hidden!important;z-index:10000!important;background:#fff!important;border-radius:8px!important;box-shadow:0 0 0 9999px rgba(0,0,0,.65),0 25px 50px rgba(0,0,0,.3)!important}body.dogg-modal .dogg-modal-target.custom-builder__component-detail-page .custom-builder__component-detail-page__back-container{position:sticky!important;top:0!important;background:#fff!important;z-index:1!important;padding:12px 16px!important;border-bottom:1px solid #eee!important;display:flex!important;justify-content:flex-end!important}body.dogg-modal .dogg-modal-target.custom-builder__component-selection-page>.custom-builder__component-selection-page__header{position:sticky!important;top:0!important;background:#fff!important;z-index:1!important}.dogg-desc-ov{font-size:inherit;line-height:1.6;white-space:pre-line}.randomising-overlay{display:flex!important;align-items:center!important;justify-content:center!important}.randomising-overlay-content{display:flex!important;flex-direction:column!important;align-items:center!important;text-align:center!important}.randomising-overlay-wheel{margin:0 auto!important}'
  // 2026-09-05 follow-up 17 (supersedes follow-up 16): follow-up 16 gave
  // every desktop pop-out extra height, but that 95vh applied to the grid
  // pop-out too, which was never wanted there - the grid pop-out on desktop
  // has now been removed entirely instead (see getActivePage below), so this
  // is rescoped to the "more info" detail page specifically, the only one
  // that still pops out on desktop. Also dialled back from 95vh to 60vh,
  // which suits the detail page's own (typically shorter) content better;
  // mobile is untouched and still uses the 85vh set above.
  +'@media screen and (min-width:768px){body.dogg-modal .dogg-modal-target.custom-builder__component-detail-page{height:60vh!important;max-height:60vh!important}}';
// 2026-09-04/05 follow-ups 9-11 (pull-to-refresh, page-width clipping, pop-out
// height/overflow) are unchanged above; this rule was then generalised
// (2026-09-05 follow-up 12, see openModal/closeModal below) from targeting
// the detail page directly to targeting a shared ".dogg-modal-target" marker
// class, because the component-selection page (the "Select Deck" etc. grid)
// now pops out the same way, and the app can leave both the grid and the
// detail page "not hidden" at the same time (detail page drawn on top of the
// grid it was opened from) - CSS alone can't tell which of the two should be
// the one fixed/centred card, so JS below decides that and marks exactly one
// element at a time.
document.head.appendChild(s);

// ── Description injection ─────────────────────────────────────────────────
var cache={};
function apply(html){
  var d=document.querySelector('div[data-product-description]');
  if(!d)return;
  d.style.display='none';
  var ov=d.parentElement&&d.parentElement.querySelector('.dogg-desc-ov');
  if(ov){ov.innerHTML=html;return;}
  ov=document.createElement('div');ov.className='dogg-desc-ov';ov.innerHTML=html;
  if(d.parentElement)d.parentElement.insertBefore(ov,d);
}
function cleanupDesc(){
  var d=document.querySelector('div[data-product-description]');
  if(d)d.style.display='';
  var ov=document.querySelector('.dogg-desc-ov');
  if(ov)ov.remove();
}
function injectDesc(attempt){
  var titleEl=document.querySelector('.custom-builder__component-detail-page:not(.is-hidden) .product-title');
  if(!titleEl){if((attempt||0)<15)setTimeout(function(){injectDesc((attempt||0)+1);},200);return;}
  var title=titleEl.textContent.trim();
  if(cache[title]!==undefined){if(cache[title])apply(cache[title]);return;}
  cache[title]=null;
  fetch('/search/suggest.json?q='+encodeURIComponent(title)+'&resources%5Btype%5D=product&resources%5Blimit%5D=3')
    .then(function(r){return r.json();})
    .then(function(j){
      var prods=j.resources&&j.resources.results&&j.resources.results.products;
      if(!prods||!prods.length)return;
      var handle=(prods[0].url||'').split('/products/')[1]||prods[0].handle;
      if(!handle)return;
      return fetch('/products/'+handle+'?sections%5B%5D=dogg-builder-description')
        .then(function(r){return r.json();})
        .then(function(j2){var html=j2['dogg-builder-description'];if(!html)return;cache[title]=html;apply(html);});
    }).catch(function(){});
}

// ── Modal open/close ──────────────────────────────────────────────────────
// 2026-09-05: this centred overlay was previously desktop-only (the builder's
// own mobile layout uses transforms for its sliding panels, and stripping
// those unconditionally used to leave panels stacked side-by-side). It was
// brought back for mobile (follow-up 10) for the item-detail / "more info"
// page, whose own inline mobile layout could end up wider than the screen.
//
// Follow-up 12: the "Select Deck" etc. grid (.custom-builder__component
// -selection-page) now pops out the same way, requested so its long
// scrollable list behaves like the item-detail card rather than the page's
// own drop-down-style layout. The two pages can both be "not hidden" at once
// (the app leaves the grid mounted underneath the detail page it was opened
// from), so a single savedT/dogg-modal pair keyed off one element isn't
// enough - activeModalEl below tracks whichever of the two should currently
// be the one fixed/centred card, and only the none<->something transitions
// touch the shared ancestor-transform-stripping and body class (switching
// between the two pages themselves just swaps which one carries the marker
// class, since they share the same ancestor chain).
var savedT=[];
var activeModalEl=null;
var lockedScrollY=0;

// 2026-09-05 follow-up 14: opening the grid straight from the landing page
// (the "SELECT X" list) left nothing visible behind the pop-out but a dark
// dimmed gap, and the page content below the builder jumped up to fill it -
// the landing page itself gets hidden/collapsed by the app the same moment
// the grid becomes the active page (unlike grid->detail, where the grid
// stays mounted and visible behind the detail pop-out on its own, so no
// jump happens there). Tried showing a live copy of the list dimmed behind
// the pop-out first, but the app's own script re-collapses any copy of that
// list wherever it appears on the page (moving it, renaming its classes -
// nothing stopped it), and chasing that further risked instability on a
// live app we don't control. Falling back to the reliable half of the fix:
// lock the builder's on-page height to what it measured right before the
// list collapsed, so the page below no longer jumps - the space behind the
// pop-out is a plain dimmed gap rather than the actual list, but nothing
// else on the page moves.
var pendingLandingHeight=null;
var lockedHeightEl=null;
document.addEventListener('click',function(e){
  var lp=e.target.closest&&e.target.closest('.custom-builder__landing-page');
  if(!lp)return;
  var cb=lp.closest('.custom-builder');
  pendingLandingHeight=cb?cb.getBoundingClientRect().height:null;
},true);

function lockBackgroundScroll(){
  // 2026-09-05 follow-up 13: right as the pop-out opened, a scroll gesture
  // could still scroll the page behind it (the card is fixed on screen, but
  // the underlying page wasn't actually prevented from scrolling under it).
  // Pin the body in place at its current scroll position while a pop-out is
  // open - this is the standard cross-browser-reliable way to do that (a
  // plain overflow:hidden on body doesn't reliably stop touch-scrolling on
  // iOS Safari), then undo it and restore the scroll position on close.
  lockedScrollY=window.scrollY||window.pageYOffset||0;
  document.body.style.position='fixed';
  document.body.style.top='-'+lockedScrollY+'px';
  document.body.style.left='0';
  document.body.style.right='0';
  document.body.style.width='100%';
}
function unlockBackgroundScroll(){
  document.body.style.position='';
  document.body.style.top='';
  document.body.style.left='';
  document.body.style.right='';
  document.body.style.width='';
  window.scrollTo(0,lockedScrollY);
}
function getActivePage(){
  // Detail page wins when both are present and not hidden - it's the one
  // drawn on top (opened from the grid, which stays mounted behind it).
  var dt=document.querySelector('.custom-builder__component-detail-page:not(.is-hidden)');
  if(dt)return dt;
  // 2026-09-05 follow-up 17: the "Select Deck" etc. grid pop-out (added in
  // follow-up 12) was requested for mobile, where the grid's own inline
  // layout didn't fit well full-page. On desktop the grid should look and
  // behave exactly as it did before follow-up 12 - so on desktop (>=768px,
  // matching the breakpoint used elsewhere in this file) the grid is left
  // out of the modal system entirely: it's never marked as the active
  // pop-out, so it keeps its own normal in-page layout, and none of the
  // pop-out's background scroll-lock/outside-click/height-lock behavior
  // applies to it either. The "more info" detail page above is unaffected
  // and keeps popping out on both mobile and desktop.
  if(window.innerWidth>=768)return null;
  var sp=document.querySelector('.custom-builder__component-selection-page:not(.is-hidden)');
  if(sp)return sp;
  return null;
}
function syncModal(){
  var next=getActivePage();
  if(next===activeModalEl)return;
  var wasActive=!!activeModalEl;
  var willBeActive=!!next;
  if(activeModalEl)activeModalEl.classList.remove('dogg-modal-target');
  if(next)next.classList.add('dogg-modal-target');
  if(!wasActive&&willBeActive){
    var el=next.parentElement;
    while(el&&el!==document.documentElement){
      var cs=window.getComputedStyle(el);
      if(cs.transform&&cs.transform!=='none'){savedT.push({el:el,v:el.style.transform});el.style.transform='none';}
      el=el.parentElement;
    }
    document.body.classList.add('dogg-modal');
    document.addEventListener('click',outsideClick,true);
    lockBackgroundScroll();
    if(next.classList.contains('custom-builder__component-selection-page')&&pendingLandingHeight){
      var cbEl=next.closest('.custom-builder');
      if(cbEl){lockedHeightEl=cbEl;cbEl.style.minHeight=pendingLandingHeight+'px';}
    }
    pendingLandingHeight=null;
  }else if(wasActive&&!willBeActive){
    document.body.classList.remove('dogg-modal');
    savedT.forEach(function(o){o.el.style.transform=o.v;});
    savedT=[];
    document.removeEventListener('click',outsideClick,true);
    cleanupDesc();
    unlockBackgroundScroll();
    if(lockedHeightEl){
      lockedHeightEl.style.minHeight='';
      lockedHeightEl=null;
    }
  }
  // The product image gallery (glide carousel) inside the detail page, and
  // the product grid inside the selection page, size themselves against
  // their container's width at render time and don't redo that automatically
  // when the container is then resized by the dogg-modal CSS - nudge
  // whichever is now active (or was just deactivated) to recalculate instead
  // of staying at the page's full width (which caused horizontal overflow).
  setTimeout(function(){window.dispatchEvent(new Event('resize'));},0);
  if(next&&next.classList.contains('custom-builder__component-detail-page')){
    setTimeout(function(){injectDesc(0);},50);
  }
  activeModalEl=next;
}
function outsideClick(e){
  var el=activeModalEl;
  if(el&&!el.contains(e.target)){e.stopPropagation();var b=el.querySelector('.btn--close');if(b)b.click();}
}

// 2026-09-05 follow-up 13: hitting "Add" on a product card in the pop-out
// grid (.btn-atc - just "Add"/"Remove", not to be confused with the detail
// page's own "Add to scooter" button, .btn--atc, which already navigates
// back to the builder on its own) left the grid pop-out open afterwards.
// Requested: close it and return to the builder page automatically, the same
// way the detail page's add button already does. Only fires on an actual add
// (button read "Add", not "Remove", right before the click) so removing an
// item from the grid doesn't also boot the customer back out.
document.addEventListener('click',function(e){
  var btn=e.target.closest&&e.target.closest('.component-product-card .btn-atc');
  if(!btn)return;
  var label=(btn.textContent||'').trim().toLowerCase();
  // 2026-10-16: also close on "Pre-order" - pre-order cards show that label
  // instead of "Add", so the pop-out used to stay open after adding one.
  if(label!=='add'&&label!=='pre-order')return;
  setTimeout(function(){
    var sp=document.querySelector('.custom-builder__component-selection-page:not(.is-hidden)');
    if(sp){var b=sp.querySelector('.btn--close');if(b)b.click();}
  },400);
},true);

// ── Pre-order badge colour (card grid) ───────────────────────────────────────
function fixPreOrderColor(){
  var root=document.querySelector('[data-app-layer-portal]')||document.body;
  root.querySelectorAll('.component-product-card__image-oos').forEach(function(el){
    if(/^EXPECTED/i.test((el.textContent||'').trim())){
      el.style.setProperty('background-color','#9333ea','important');
      el.style.setProperty('color','#fff','important');
      el.style.setProperty('border-color','#9333ea','important');
    }
  });
}
setTimeout(fixPreOrderColor,500);
setTimeout(fixPreOrderColor,1500);
setTimeout(fixPreOrderColor,3000);

// ── Mobile: remove "Back to preview" button + shrink listing "Next" button ──
// Requested 2026-09-04: the scroll-top "Back to preview" pill (LandingPage
// __components section) stays fixed on screen and floats over the component
// listing/detail content on mobile — remove it entirely. Also shrink the
// "Next" button (builderLanguageStrings.listing_next_button) in the
// component-selection-page footer, which was oversized on small phones.
(function(){
  var hasBuilder=!!document.querySelector('.custom-builder');
  var s2=document.createElement('style');
  s2.textContent='.custom-builder__landing-page .scroll-top{display:none!important}'
    +'.custom-builder__component-selection-page__footer .btn.btn-primary{width:auto!important;padding:10px 20px!important;font-size:13px!important}'
    +'.custom-builder__component-selection-page__footer .btn.btn-primary svg{width:12px!important;height:12px!important}'
    // 2026-09-04 follow-up: shrinking the Next button didn't fix the overlap -
    // its footer is position:sticky and still floats over grid rows that
    // haven't scrolled past yet on mobile. Hide it there entirely; users can
    // still reach the next part from the parts list on the landing page.
    +'@media screen and (max-width:767px){.custom-builder__component-selection-page__footer{display:none!important}}'
    // 2026-09-04 follow-up 2: on the landing page's selected-component rows,
    // Change/Remove stack in a fixed-width column to the right of the title,
    // squeezing the title into a narrow space and making long product names
    // wrap tall. On mobile, wrap the row so Change/Remove drop below the
    // title as a horizontal pair instead, aligned under the text (not the
    // image). Scoped to .is-selected only - unselected rows just show a
    // small ">" arrow in .actions and must keep their original compact,
    // vertically-centred layout (qualifying broadly pushed that arrow onto
    // its own line with a large gap, which is what follow-up 2b fixes).
    +'@media screen and (max-width:767px){'
    +'.custom-builder__landing-page__component-card.is-selected{flex-wrap:wrap!important}'
    +'.custom-builder__landing-page__component-card.is-selected .custom-builder__landing-page__component-card__image-description{flex:1 1 100%!important;margin-right:0!important;padding-bottom:0!important}'
    +'.custom-builder__landing-page__component-card.is-selected .custom-builder__landing-page__component-card__description{padding-bottom:0!important}'
    +'.custom-builder__landing-page__component-card.is-selected .custom-builder__landing-page__component-card__actions{flex-direction:row!important;justify-content:flex-start!important;align-items:center!important;width:100%!important;padding:2px 16px 12px 120px!important;margin:0!important;gap:16px!important}'
    +'.custom-builder__landing-page__component-card.is-selected .custom-builder__landing-page__component-card__actions .label{margin:0!important}'
    +'}'
    // 2026-09-04 follow-up 3: the "?" info tooltip button on each landing-page
    // row adds clutter and makes the row harder to scan on mobile - hide it
    // there (still shown on desktop, where there's room for it).
    +'@media screen and (max-width:767px){.custom-builder__landing-page .btn--tooltip.inline-tooltip{display:none!important}}'
    // 2026-09-04 follow-up 4: drop the "Required" label on every landing-page
    // row on mobile for a cleaner "SELECT X" / product-title line - it's
    // redundant (every listed component is required) and added visual noise.
    +'@media screen and (max-width:767px){.custom-builder__landing-page .is_required{display:none!important}}'
    // 2026-09-04 follow-up 5: on the component-listing pages (Select Deck,
    // Select Bars, etc.) the product cards show title and price side-by-side
    // (space-between), which squeezes a multi-line title against the price.
    // Requested: match a competitor's layout - price stacked under the title,
    // smaller title text, and a smaller "Add" button (both text and button size).
    // 2026-09-04 follow-up 5b: keep price right-aligned once stacked (not left).
    // Also: for multi-variant products (e.g. decks with several sizes) the app
    // shows a "Choose Size" button (.btn-product-options) instead of "Add" -
    // that one wasn't covered by the .btn-atc rule above, so it stayed full
    // size. Shrink it to match.
    //
    // 2026-09-11 follow-up 19: the stacked title-then-price layout (and its
    // right-aligned price) is no longer mobile-only - a narrower desktop
    // browser window runs into the same side-by-side squeeze, so those two
    // rules moved out of the max-width:767px block below and now apply at
    // every width. The smaller title text and smaller Add/Choose Size button
    // stay mobile-only - that's a small-screen density tweak, not part of
    // what was asked for here.
    +'.component-product-card__title-price{flex-direction:column!important}'
    +'.component-product-card__price{margin:2px 0 8px!important;text-align:right!important}'
    +'@media screen and (max-width:767px){'
    +'.component-product-card__title,.component-product-card__title__title{font-size:11px!important;line-height:1.4!important}'
    +'.component-product-card__btns .btn-atc,.component-product-card__btns .btn-product-options{height:32px!important;min-height:32px!important;padding:6px 0!important;font-size:11px!important}'
    +'}'
    // 2026-09-04 follow-up 6: the empty "+" placeholder icon on unselected
    // landing-page rows (custom-builder-plus-icon.svg, 42x42 intrinsic) is set
    // as a background-image on the row's short single-line description box and
    // anchored top-left, so most of its height hangs below that box with only
    // a few px of clearance to the row's bottom edge - on some phones (font
    // size/line-height variance) that clearance disappears and the bottom of
    // the icon gets clipped by the next row. Shrink it and centre it vertically
    // so it always sits fully inside the row with room to spare.
    +'@media screen and (max-width:767px){.custom-builder__landing-page__component-card__description{background-size:32px 32px!important;background-position:0 center!important}}'
    // 2026-09-04 follow-up 7: brand the "Add"/"Remove" button on the
    // component-listing cards with the Dogg yellow (#ECD407, matched from the
    // site's announcement bar / filled buttons) instead of its default
    // transparent-with-dark-border look.
    +'@media screen and (max-width:767px){.component-product-card__btns .btn-atc{background-color:#ECD407!important;border-color:#ECD407!important;color:#151515!important}}'
    // 2026-09-04 follow-up 8: slightly shrink the product title on the
    // landing page once a component is selected (e.g. "Apex Pro Scooter Deck
    // - Anodized Turquoise - 4.5\"). Scoped to .is-selected only - the
    // unselected "SELECT X" labels are left at their current size.
    +'@media screen and (max-width:767px){.custom-builder__landing-page__component-card.is-selected .component-title{font-size:13px!important}}'
    // 2026-09-04 follow-up 9: prevent the browser's native "pull to refresh"
    // gesture on mobile. Scrolling up past the very top of the page (easy to
    // do by accident while browsing the builder) can trigger a full page
    // reload on Chrome/Android and some other mobile browsers, which resets
    // the builder's in-memory selections. "contain" only stops scroll from
    // chaining to a parent element — it does not stop the browser's own
    // pull-to-refresh action at the top boundary. "none" explicitly disables
    // that native browser action too.
    //
    // 2026-09-08: this rule (and the overflow-x rule below it) used to apply
    // unconditionally to html,body with no scoping at all - which meant they
    // ran on every page of the site, all the time, since this script loads
    // sitewide (footer-scripts.liquid), not just on the builder page. Setting
    // overscroll-behavior-y:none together with overflow-x:hidden on both
    // html AND body is exactly the kind of rule combination known to lock up
    // scrolling entirely on some older/lower-powered Android WebView builds
    // (rather than just suppressing the bounce/refresh gesture as intended) -
    // this matches a customer-reported "page freezes after ~1s of scrolling"
    // bug confirmed on a Zebra Android handheld. Gating both rules behind
    // hasBuilder confirmed the diagnosis (every other page now scrolls fine),
    // but the builder page itself still froze the same way, because both
    // rules were still doubled onto both html AND body there.
    //
    // 2026-09-08 (2nd pass): rather than applying each property to both root
    // elements, split them - one property per element. overscroll-behavior-y
    // needs to stay on a root element to actually block the browser's native
    // pull-to-refresh gesture (it has no effect set on a non-scrolling child),
    // so it stays here, but only on html now, not body.
    +(hasBuilder?'@media screen and (max-width:767px){html{overscroll-behavior-y:none!important}}':'')
    // 2026-09-05 follow-up 10: on mobile, selecting a component category can
    // leave the page wider than the screen (some part of the builder's
    // layout - e.g. an off-canvas panel or carousel row - briefly exceeds
    // the viewport width), so the page becomes scrollable side-to-side as
    // well as up-and-down, which is awkward to use. Clip any horizontal
    // overflow so the page can never scroll wider than the screen, without
    // touching normal vertical scrolling.
    //
    // 2026-09-08 (2nd pass): moved off html/body entirely (removing the other
    // half of the doubled-up root-element rule pair) and onto .custom-builder
    // itself instead - the overflowing content lives inside that container in
    // the DOM, so clipping it there keeps the page from being pushed wider
    // than the viewport without touching html/body's own overflow at all.
    +(hasBuilder?'@media screen and (max-width:767px){.custom-builder{overflow-x:hidden!important;max-width:100vw!important}}':'');
  document.head.appendChild(s2);
})();

// ── Grid card: level footer row + faint outline (follow-up 15, 18) ─────────
// Requested 2026-09-05: titles wrap to a different number of lines from card
// to card, which pushed each card's price/Add/More Info block down by a
// different amount - so that block didn't line up card-to-card along a row.
// The grid already stretches every card in a row to match the tallest one;
// turning each card into a flex column and pinning its button block to the
// bottom (margin-top:auto) keeps that block flush with the card's bottom
// edge no matter how tall the title above it grew, which lines it up with
// every other card in the row. This levelling applies on both mobile and
// desktop, since the misaligned-title issue isn't screen-size specific.
// Also added a faint outline per card, purely to see how it reads - follow-up
// 18 then scoped that outline (plus its padding/rounding) to mobile only,
// leaving desktop cards without it.
(function(){
  var s3=document.createElement('style');
  s3.textContent='.component-product-card{display:flex!important;flex-direction:column!important}'
    +'.component-product-card__btns{margin-top:auto!important}'
    +'@media screen and (max-width:767px){.component-product-card{border:1px solid rgba(0,0,0,.12)!important;border-radius:6px!important;padding:8px!important}}';
  document.head.appendChild(s3);
})();

// ── Filters: keep redundant single-option filters hidden (follow-up 20) ────
// Reported 2026-09-11: a filter group with only one possible value (e.g.
// Product Type, Material or Compression Type on a collection that only has
// one of each) is correctly hidden the first time a step's selection page
// is opened, but can come back on a later visit - specifically once that
// step's product list has been re-scoped by compatibility with a part
// picked elsewhere (e.g. picking SCS bars narrows Clamps down to
// SCS-compatible clamps only). The builder doesn't reliably re-run its own
// "hide if only one option" pass after that kind of re-scope. This applies
// the same rule ourselves, every time the filter list changes, so a
// redundant filter can't resurface regardless of when or why it was
// rebuilt. It only ever hides a group (never un-hides one), so it can't
// interfere with a filter that's genuinely meant to be shown.
function hideRedundantFilterGroups(){
  document.querySelectorAll('.filter-group-wrap').forEach(function(g){
    if(g.querySelectorAll('.sub-filter-list .sub-filter-item').length<=1){
      g.style.display='none';
    }
  });
}
(function(){
  var pending=false;
  function schedule(){
    if(pending)return;
    pending=true;
    setTimeout(function(){pending=false;hideRedundantFilterGroups();},50);
  }
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  schedule();
})();

// ── MutationObserver ─────────────────────────────────────────────
new MutationObserver(function(){
  fixPreOrderColor();
  syncModal();
}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});

}();